export enum BannerVariant {
  Success = 'success',
  Danger = 'Danger',
}
